package cz.lhoracek.mapl.data.repository

import kotlin.random.Random

actual fun platformRandomBytes(bytes: ByteArray) {
    bytes.indices.forEach { index ->
        bytes[index] = Random.nextInt(0, 256).toByte()
    }
}
